export enum LocalStorageKeys {
  JWT_TOKEN = 'token',
  USER = 'user',
}
